// action - flight-indicators reducer

export const FLIGHT_INDICATORS_PENDING = 'FLIGHT_INDICATORS_PENDING';
export const FLIGHT_INDICATORS_FAILURE = 'FLIGHT_INDICATORS_FAILURE';

// get flight-indicators
// export const GET_FLIGHT_INDICATORS_PENDING = 'GET_FLIGHT_INDICATORS_PENDING';
export const GET_FLIGHT_INDICATORS_SUCCESS = 'GET_FLIGHT_INDICATORS_SUCCESS';
// export const GET_FLIGHT_INDICATORS_FAILURE = 'GET_FLIGHT_INDICATORS_FAILURE';

// update flight commands
// export const UPDATE_COMMANDS_PENDING = 'UPDATE_COMMANDS_PENDING';
export const UPDATE_COMMANDS_SUCCESS = 'UPDATE_COMMANDS_SUCCESS';
// export const UPDATE_COMMANDS_FAILURE = 'UPDATE_COMMANDS_FAILURE';

// set flight commands
// export const SET_COMMANDS_PENDING = 'SET_COMMANDS_PENDING';
export const SET_COMMANDS_SUCCESS = 'SET_COMMANDS_SUCCESS';
// export const SET_COMMANDS_FAILURE = 'SET_COMMANDS_FAILURE';

// clear flight commands
// export const CLEAR_COMMANDS_PENDING = 'CLEAR_COMMANDS_PENDING';
export const CLEAR_COMMANDS_SUCCESS = 'CLEAR_COMMANDS_SUCCESS';
// export const CLEAR_COMMANDS_FAILURE = 'CLEAR_COMMANDS_FAILURE';
